





































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import _ from 'lodash/fp';
import { VinSearchModuleTypes } from '@/store/modules/vin-search';
import BaseMixin from '@/mixins/BaseMixin';
import URI from 'urijs';

@Component({
    components: {
        LoadingIndicator,
    },
})
export default class VinSearch extends Mixins(BaseMixin) {
    @Prop(String)
    private catalogueSearchLink!: string;

    private searchTerm: string = '';
    private searchDebounced: () => void = _.debounce(500, () => {
        this.search();
    });

    public get loadingFailed(): boolean {
        return this.$store.getters[VinSearchModuleTypes.getters.searchResultsLoadingState] === LoadingState.Failed;
    }

    public get isLoading(): boolean {
        return this.$store.getters[VinSearchModuleTypes.getters.searchResultsLoadingState] === LoadingState.Loading;
    }

    public get isSearchTermValid(): boolean {
        return this.searchTerm != null && this.searchTerm.trim() !== '' && this.searchTerm.trim().length === 17;
    }

    public search(): void {
        if (this.isSearchTermValid) {
            if (this.isDesktop) {
                this.$store.dispatch(VinSearchModuleTypes.actions.loadSearchResults, {
                    searchTerm: this.searchTerm,
                    brand: '',
                });
            } else {
                document.location.href = new URI(this.catalogueSearchLink).addQuery({ searchTerm: this.searchTerm }).toString();
            }
        }
    }

    public get isDesktop(): boolean {
        // (this as any) necassary because of the missing types for vue-mq
        return (this as any).$mq === 'lg' || (this as any).$mq === 'xl';
    }

    @Watch('searchTerm')
    private onSearchTermChange(): void {
        if (!this.isDesktop) {
            return;
        }
        this.searchDebounced();
    }
}
